import Vue from 'vue/dist/vue.esm.js';

Vue.component('RequestDetailComponent', require('./components/RequestDetailComponent').default);

const requestDetailComponent = new Vue({
    el: '#request-detail',
});
